import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { OpenInNew } from '../../assets/icons'
import Table from '../../components/Table'
import ButtonIcon from '../../components/templates/ButtonIcon'
import SimpleCard from '../../components/templates/SimpleCard'
import { userActions } from '../../redux/actions/userActions'
import templateStyles from '../../components/templates/templates.module.scss'
import TextField from '../../components/Forms/TextField'
import { UserRoleTypes } from '../../utils/enums/userRoleTypes'
import format from 'date-fns/format'
import UserStatuses from './UserStatuses'
import UserStatusesStep from './StepStatus'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

const MainTab = () => {
  const dispatch = useDispatch();
  const query = new URLSearchParams(useLocation().search)
  const triger = query.get("triger");
  const {
    items,
    tableConfig: {
      isLoading,
      page,
      totalData,
      limit,
      sort,
      filter
    }
  } = useSelector(state => state.user);

  const load = useCallback(
    () => {
      const tConfig = {
        limit,
        page,
        sort,
        filter
      }
      return dispatch(userActions.loadRequested(tConfig))
    },
    [dispatch, limit, page, sort, filter],
  )

  const setTableConfig = useCallback(
    key => value => dispatch(userActions.setTableConfig(key, value)),
    [dispatch]
  )
  const setTableConfigFilter = useCallback(
    key => value => dispatch(userActions.setTableConfigFilter(key, value)),
    [dispatch]
  )

  useEffect(() => {
    load()
  }, [load])

  useEffect(() => {
    if(triger) {
      const data = JSON.parse(query.get("data"))
      dispatch(userActions.createTab(data._id, data.fullName))
    }
  
  }, [triger])

  const columns = useMemo(() => ([
    {
      title: 'Waktu Dibuat', key: 'createdAt', render: v => format(new Date(v), 'd MMM yyyy, HH:mm:ss')
    },
    {
      title: 'Nama', key: 'fullName'
    },
    {
      title: 'Perusahaan', key: 'company', render: v => v.map(e=>e.name)
    },
    {
      title: 'Email', key: 'email'
    },
    {
      title: 'Peran', key: 'role', render: v => UserRoleTypes.getStr(v)
    },
    { title: 'Step', render: (v, row) => <UserStatuses status={v} /> },
    { title: 'Status', render: (v, row) => <UserStatusesStep status={v} /> },
    {
      title: '', key: '_id', render: (v, row) => (
        <div className={templateStyles.buttonGroup}>
          <ButtonIcon
            icon={<OpenInNew />}
            onClick={() => dispatch(userActions.createTab(v, row.fullName))}
          />
        </div>
      )
    }
  ]), [dispatch]);

  const excelColumns = [
    { title: 'Nama', key: 'fullName' },
    { title: 'No Handphone', key: 'phoneNumber' },
    { title: 'Email', key: 'email' },
    { title: 'Peran', key: 'role', render: v => UserRoleTypes.getStr(v) },
    { title: 'Status', key: 'status', render: (v, row) => <UserStatuses user={row} forExcel /> },
  ]

  return (
    <div>
      <SimpleCard>
        <Table
          data={items}
          excel={{
            columns: excelColumns,
            filename: 'Table Users',
            api: {
              apiResponseKey: "user",
              service: userActions.loadRequested({ limit, page, sort, filter }),
            },
          }}
          onReload={load}
          onChangePage={setTableConfig('page')}
          onSort={setTableConfig('sort')}
          config={{
            loading: isLoading,
            columns,
            total: totalData,
            limit,
            sort,
            currentPage: page,
            showRender: (from, to, total) => `${from}-${to} dari ${total} User`
          }}
        >
          <div className="row mb-12">
            <div className="col-md-3">
              <TextField
                variant="outlined"
                label="Cari"
                placeholder="Ketik Sesuatu..."
                value={filter.search}
                onChange={e => setTableConfigFilter('search')(e.target.value)}
              />
            </div>
          </div>
        </Table>
      </SimpleCard>
    </div >
  )
}

export default MainTab
